<template class="main1">
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="main1">
      <div class="login">
        <el-card>
          <h2>Login to JoBase</h2>
          <el-form  @submit.prevent>
            <el-form-item prop="username">
              <el-input class="tst-username-field" v-model="credentials.email" placeholder="Username" prefix-icon="fas fa-user"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <!-- on click -->
              <el-input class="tst-password-field"
                @keyup.native.enter="submit()"
                v-model="credentials.password"
                placeholder="Password"
                type="password"
                prefix-icon="fas fa-lock"
              ></el-input>
            </el-form-item>
            <div v-if="this.notRegistered == true">
              <p style="font-size: 13px; color: red; display: inline;">
                can not sign in. please confirm your email address with the link sent to your email </p>
              <a style="margin-left: 32px; font-size: 13px;" @click="resendEmail(credentials.email)"> Resend email </a>
            </div>
            <el-form-item>
              <el-button
                @click.native="submit()"
                v-on:keyup.enter="submit()"
                class="tst-login-button"
                block
              >Login</el-button>
            </el-form-item>
            <router-link to="/ResetPassword">Forgot password ?</router-link>
            <br />
            <br />No Account?
            <router-link to="/Register">Register</router-link>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LogRocket from 'logrocket';
import EventService from "@/services/EventService.js";
import EventBus from '@/services/EventBus.js';

export default {
  components: {},
  data() {
    return {
      credentials: this.newCreds(),
      notRegistered: null,
      loadingFormSubmit: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },

  methods: {
    newCreds() {
      return {
        email: "",
        password: ""
      };
    },
    submit() {
      this.loadingFormSubmit = true;
      
      return this.$store
        .dispatch("logIn", this.credentials)
        .then((response) => {
          
            LogRocket.identify(response.userid, {
                  name: response.firstname + " " + response.lastname,
                  email: response.userName,
                // Add your own custom user variables here, ie:
                subscriptionType: 'pro'
            });
 
              this.credentials = this.newCreds();
              
              EventBus.$emit("user-logged-in")

              this.$router.push({ name: "DashboardAllProperties" });
        })
        .catch(error => {

            this.loadingFormSubmit = false;

            // this is the error message the interceptor returns 
            if(error == "confirm email address error")
            {
                this.notRegistered = true;
                return
            }

        });
    },
     resendEmail(email) {
      EventService.ResendRegistrationConfirmationEmail(email).then( ()=> {
                   this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Re-sent confirmation email"
          })
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
$teal: rgb(0, 124, 137);
.el-button--primary {
  background: $teal;
  border-color: $teal;

  &:hover,
  &.active,
  &:focus {
    background: lighten($teal, 7);
    border-color: lighten($teal, 7);
  }
}
.login .el-input__inner:hover {
  border-color: $teal;
}
.login .el-input__prefix {
  background: rgb(238, 237, 234);
  left: 0;
  height: calc(100% - 2px);
  left: 1px;
  top: 1px;
  border-radius: 3px;
  .el-input__icon {
    width: 30px;
  }
}
.login .el-input input {
  padding-left: 35px;
}
.login .el-card {
  padding-top: 0;
  padding-bottom: 30px;
}
h2 {
  font-family: "Open Sans";
  letter-spacing: 1px;
  font-family: Roboto, sans-serif;
  padding-bottom: 20px;
}
a {
  color: $teal;
  text-decoration: none;
  &:hover,
  &:active,
  &:focus {
    color: lighten($teal, 7);
    cursor: pointer;
  }
}
.login .el-card {
  width: 340px;
  display: flex;
  justify-content: center;
}

.bound {
  display: flex;
  align-items: center;
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.5);
  background-color: white;
  border-radius: 7px;
  width: 350px;
  height: 385px;
  margin: 7px;
  flex-direction: column;
  /* transform: translateY(-50%) */
}

.main1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
